import { useState } from 'react'

import { useDisclosure } from '@mantine/hooks'

import { useQuery } from '@redwoodjs/web'

import AdminContainer from 'src/components/AdminContainer/AdminContainer'
import DNButton from 'src/components/Buttons/Button/DNButton'
import { GET_VOICE_AGENTS } from 'src/graphql/voiceAgents.graphql'

import AddVoiceAgentModal from './components/AddVoiceAgentModal'
import VoiceAgentDetailsPage from './VoiceAgentDetailsPage'
import VoiceAgentsTable from './VoiceAgentsTable'

const VoiceAgentsTab = () => {
  const [selectedVoiceAgent, setSelectedVoiceAgent] = useState(null)
  const [addModalOpened, addModalHandlers] = useDisclosure(false)

  const {
    data,
    loading,
    refetch: refetchVoiceAgents,
  } = useQuery(GET_VOICE_AGENTS, {
    variables: {
      pageInfo: { limit: 100, offset: 0 },
    },
  })

  const voiceAgents = data?.voiceAgents?.items ?? []

  // Keep the selected agent fresh after per-card saves refetch the list —
  // the state object is a snapshot from selection time.
  const currentVoiceAgent = selectedVoiceAgent
    ? voiceAgents.find(
        (va) => va.voiceAgentId === selectedVoiceAgent.voiceAgentId
      ) ?? selectedVoiceAgent
    : null

  return (
    <div className="flex h-full flex-col gap-6">
      {currentVoiceAgent ? (
        <VoiceAgentDetailsPage
          voiceAgent={currentVoiceAgent}
          setSelectedVoiceAgent={setSelectedVoiceAgent}
          refetchVoiceAgents={refetchVoiceAgents}
        />
      ) : (
        <>
          <div className="flex flex-row items-start justify-between">
            <div className="flex flex-col">
              <div className="text-lg font-semibold text-doubleNickel-gray-900">
                Voice Agents
              </div>
              <div className="text-sm text-doubleNickel-gray-600">
                {voiceAgents.length} voice agents
              </div>
            </div>
            <AdminContainer>
              <DNButton
                variant="primary"
                onClick={() => addModalHandlers.open()}
              >
                Add Voice Agent
              </DNButton>
            </AdminContainer>
          </div>
          <VoiceAgentsTable
            voiceAgents={voiceAgents}
            loading={loading}
            setSelectedVoiceAgent={setSelectedVoiceAgent}
          />
          <AddVoiceAgentModal
            opened={addModalOpened}
            close={addModalHandlers.close}
          />
        </>
      )}
    </div>
  )
}

export default VoiceAgentsTab
